define( 'helper',[ 'jquery' ],
	function ( $ ) {

		'use strict';

		/**
		 * Iterates over all $helpers and initiates helper controller.
		 */

		return {

			init: function ( $helpers ) {

				// if initComponent was invoked, use $helpers. otherwise it's the bootstrap init call
				if ( typeof( $helpers ) === 'undefined' ) {

					$helpers = $( '[ data-helper ]' );

				}

				$helpers.each( function () {

					var $helper = $( this ),
						id = $helper.data( 'helper' );

					//Retrieves the id of the module from the 'helper' data attribute and calls the relevant controller.
					require( [ '../src/sublayouts/_helpers/' + id + '/' + id ], function ( Helper ) {

						var helper;

						if ( Helper !== undefined ) {

							helper = new Helper( $helper );
							helper.init();
						}
					} );
				} );
			}
		};
	} );

